import React from 'react'

const Print = (
  {
    color
  }
) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M46,24.5c-0.6,0-1-0.4-1-1V12.4H20v11.1c0,0.6-0.4,1-1,1s-1-0.4-1-1V11.4c0-0.6,0.4-1,1-1h27c0.6,0,1,0.4,1,1
	v12.1C47,24,46.6,24.5,46,24.5z"/>
      <path fill={color} d="M55,44h-9c-0.6,0-1-0.4-1-1s0.4-1,1-1h8V24.5H11V42h8c0.6,0,1,0.4,1,1s-0.4,1-1,1h-9c-0.6,0-1-0.4-1-1V23.5
	c0-0.6,0.4-1,1-1h45c0.6,0,1,0.4,1,1V43C56,43.6,55.6,44,55,44z"/>
      <path fill={color} d="M46,54.6H19c-0.6,0-1-0.4-1-1V35.5c0-0.6,0.4-1,1-1h27c0.6,0,1,0.4,1,1v18.1C47,54.1,46.6,54.6,46,54.6z
	 M20,52.6h25V36.5H20V52.6z"/>
      <path fill={color} d="M49,30.5h-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S49.6,30.5,49,30.5z"/>
      <path fill={color} d="M40,48.6H25.5c-0.6,0-1-0.4-1-1s0.4-1,1-1H40c0.6,0,1,0.4,1,1S40.6,48.6,40,48.6z M40,42.8H25.5
	c-0.6,0-1-0.4-1-1s0.4-1,1-1H40c0.6,0,1,0.4,1,1S40.6,42.8,40,42.8z"/>
    </svg>
  )
}

export default Print
